import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import SPACheckbox from '../../shared/SPACheckbox';
import SPASectionHeading from '../../shared/SPASectionHeading';
import { useSPAToast } from '../../shared/SPAToast';
import { PanelFooter, hintClass, panelClass } from '../../shared/formPanel';
import { EditableProgram, ProgramUpdatePayload, useUpdateProgram } from './useProgram';

interface FormValues {
  depth_of_knowledge: boolean;
  tags: boolean;
}

const QuestionBankFiltersPanel = () => {
  const program = useOutletContext<EditableProgram>();
  const spaToast = useSPAToast();
  const updateProgram = useUpdateProgram(program.id);
  const values = useMemo(
    () => ({ depth_of_knowledge: program.depth_of_knowledge, tags: program.tags }),
    [program],
  );
  const { handleSubmit, register } = useForm<FormValues>({ values });

  const save = (formValues: ProgramUpdatePayload) => {
    updateProgram.mutate(formValues, {
      onSuccess: () => spaToast.success('Saved question bank filters.'),
    });
  };

  return (
    <form noValidate className={panelClass} onSubmit={handleSubmit(save)}>
      <SPASectionHeading className="tw-mb-1" title="Question Bank Filters" />
      <span className={`${hintClass} tw-mb-4 tw-mt-0`}>Which filters the question bank offers for this program.</span>

      <div className="tw-flex tw-flex-col tw-gap-3.5">
        <SPACheckbox {...register('depth_of_knowledge')}>Depth of knowledge</SPACheckbox>
        <SPACheckbox {...register('tags')}>Tags</SPACheckbox>
      </div>

      <PanelFooter update={updateProgram} />
    </form>
  );
};

export default QuestionBankFiltersPanel;
